import { Component, OnInit , ViewChild} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs'
import { TicketsService } from 'src/app/_services/tickets.service';
import { User } from 'src/app/_models';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
export interface PeriodicElement {
  name: string;
  no: number;
  assignedTo: string;
  startDate: string;
  status: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {no: 1, name: '0365--Minimal', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Completed'},
  {no: 2, name: '0365--Resolving stopped Dir sync services or problems syncing with office - Critical', assignedTo:'iLink Support', startDate: '02/06/2020', status: 'Completed'},
  {no: 3, name: 'issue with once drive sync', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Pending'},
  {no: 4, name: '0365--Critical', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Completed'},
  {no: 5, name: '0365--Outlook connectivity -Minimal', assignedTo:'iLink Support', startDate: '12/03/2018', status: 'Completed'},
  {no: 6, name: '0365--Minimal', assignedTo:'Csp Support', startDate: '05/02/2019', status: 'Pending'},
  {no: 7, name: '0365--Minimal', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Completed'},
  {no: 8, name: '0365--Resolving stopped Dir sync services or problems syncing with office - Critical', assignedTo:'iLink Support', startDate: '02/06/2020', status: '07/06/2020'},
  {no: 9, name: 'issue with once drive sync', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Completed'},
  {no: 10, name: '0365--Critical', assignedTo:'Csp Support', startDate: '05/06/2020', status: 'Pending'},
 

];


@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.css']
})
export class MyTicketsComponent   {
    displayedColumns: string[] = [ 'no','name', 'assignedTo', 'startDate','status'];
  //dataSource = ELEMENT_DATA;

  @ViewChild(MatPaginator) paginator: MatPaginator;

    total : number;
    loading = true;
    error = '';
    dataSource;
    isUserLoggedIn = false;
    arr;
    title = 'materialApp'; 
    color = 'primary';
    mode = 'indeterminate';
    value = 75;
    diameter=60
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public userId :  string

  constructor(private ticketservice : TicketsService) { 

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId =  this.currentUserSubject.value.userId;
    this.isUserLoggedIn = this.currentUser == null ? false : true;

    ticketservice.getMyTicketList(this.userId).subscribe(
      res => {        
          // this.dataSource = <any>res;
          // this.total =  this.dataSource.length;  
          this.arr = res  
          this.dataSource = new MatTableDataSource(this.arr); 
          this.dataSource.paginator = this.paginator;    
          this.total =  this.arr.length;  
          this.loading = false;
                  
      },
      error => {  
        this.error = error;
        this.loading = false;
    });
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator; 
  }

}


